export const IPC_CHANNELS = {
  // 模特库
  MODEL_LIST: 'model:list',
  MODEL_GET: 'model:get',
  MODEL_CREATE: 'model:create',
  MODEL_UPDATE: 'model:update',
  MODEL_DELETE: 'model:delete',

  // 提示词
  PROMPT_LIST: 'prompt:list',
  PROMPT_GET: 'prompt:get',
  PROMPT_CREATE: 'prompt:create',
  PROMPT_UPDATE: 'prompt:update',
  PROMPT_DELETE: 'prompt:delete',
  PROMPT_IMPORT_DEFAULTS: 'prompt:import-defaults',
  PROMPT_BUILD_TASK: 'prompt:build-task',

  // 任务队列
  TASK_LIST: 'task:list',
  TASK_CREATE: 'task:create',
  TASK_CANCEL: 'task:cancel',
  TASK_RETRY: 'task:retry',
  TASK_DELETE: 'task:delete',
  TASK_CLEAR_COMPLETED: 'task:clear-completed',

  // 结果管理
  RESULT_LIST: 'result:list',
  RESULT_GET: 'result:get',
  RESULT_DELETE: 'result:delete',
  RESULT_DELETE_OUTPUTS: 'result:delete-outputs',
  RESULT_EXPORT: 'result:export',
  RESULT_OPEN_DIR: 'result:open-dir',

  // 设置
  SETTINGS_GET: 'settings:get',
  SETTINGS_SET: 'settings:set',
  SETTINGS_GET_ALL: 'settings:get-all',

  // 文件系统
  FILE_UPLOAD: 'file:upload',
  FILE_DELETE: 'file:delete',
  FILE_COPY: 'file:copy',
  FILE_OPEN_DIALOG: 'file:open-dialog',
  FILE_SAVE_DIALOG: 'file:save-dialog',
  FILE_SAVE_PASTED_IMAGE: 'file:save-pasted-image',

  // 图片处理
  IMAGE_RESIZE: 'image:resize',
  IMAGE_THUMBNAIL: 'image:thumbnail',
  IMAGE_GET_INFO: 'image:get-info',

  // AI Provider
  AI_GENERATE: 'ai:generate',
  AI_TEST_CONNECTION: 'ai:test-connection',
  AI_GET_PROVIDERS: 'ai:get-providers',

  // 模型服务状态
  MODEL_HEALTH_GET: 'model-health:get',

  // 任务进度推送（主进程 → 渲染进程）
  TASK_PROGRESS: 'task:progress',
  TASK_STATUS_CHANGE: 'task:status-change',
  TASK_OUTPUT_READY: 'task:output-ready',
  TASK_QUEUE_COMPLETE: 'task:queue-complete',
} as const;

export type IpcChannel = typeof IPC_CHANNELS[keyof typeof IPC_CHANNELS];
